export class ItemEpisode {
    name: string;
    description: string;
}
